export const downloadFileBlob = (filename: string, blob: Blob): void => {
  const a = document.createElement('a');
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const downloadFileText = (
  filename: string,
  text: string,
  resolve: () => void,
  reject: (e: Error) => void,
) => {
  try {
    const element = document.createElement('a');
    element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`);
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
    resolve();
  } catch (e: any) {
    // console.log('Error on download', e);
    reject(e);
  }
};

const dummyFunc = () => {};
export const downloadFile = (
  filename: string,
  text: string,
  resolve = dummyFunc,
  reject = dummyFunc,
) => {
  downloadFileText(filename, text, resolve, reject);
};
